module.exports = __webpack_public_path__ + "static/img/mechanism-of-action.de7a1a66.png";